import React from 'react';
import PropTypes from 'prop-types';

// import ThemeContext from '../../../config/themeContext';

export default function AdLabel({ labelText, cid }) {
  // const theme = useContext(ThemeContext);

  const showCid = cid ? <span className="tpx-ext-label-cid">cid</span> : null;
  return (
    <div className="tpx-ext-label">
      <span className="tpx-ext-label-text">{labelText}</span>&nbsp;
      {showCid}
    </div>
  );
}

AdLabel.propTypes = {
  labelText: PropTypes.string.isRequired,
  cid: PropTypes.number.isRequired,
};
